<template>
    <div class="product-service">
        <div class="row">
            <!-- 左边目录 -->
            <div class="fl w235">
                <div class="sideTitle2">
                    <div class="list-img">
                        <h5>产品技术服务</h5>
                    </div>
                    <div class="list">
                        <ul>
                            <li :class="activeTab === 'company' ? 'active' : ''" @click="switchTab('company')">
                                <p>产品公司列表</p>
                                <i class="el-icon-arrow-right"></i>
                            </li>
                            <li :class="activeTab === 'product' ? 'active' : ''" @click="switchTab('product')">
                                <p>产品列表</p>
                                <i class="el-icon-arrow-right"></i>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="sideImg">
                    <img src="../../../assets/image/mxu.jpg" alt="">
                </div>
            </div>
            <!-- 右边内容 -->
            <div class="fr w750">
                <div class="pageBox2">
                    <!-- 产品公司列表 -->
                    <div v-if="activeTab === 'company'">
                        <div class="company-list">
                            <ul>
                                <li v-for="company in companyList" :key="company.id" @click="viewCompanyProducts(company)">
                                    <a href="javascript:;">{{ company.unitName }}</a>
                                    <span>{{ company.createTime }}</span>
                                </li>
                            </ul>
                        </div>
                        <div class="pages">
                            <el-pagination 
                                @size-change="handleCompanySizeChange" 
                                @current-change="handleCompanyCurrentChange" 
                                small
                                layout="prev, pager, next" 
                                :total="companyTotal"
                                :page-size="companyQueryParams.pageSize"
                                :current-page="companyQueryParams.pageNum">
                            </el-pagination>
                        </div>
                    </div>
                    
                    <!-- 公司产品详情 -->
                    <div v-else-if="activeTab === 'productDetail'">
                        <!-- 公司信息 -->
                        <div class="company-info">
                            <h3>{{ selectedCompany.unitName }}</h3>
                            <p><strong>官网地址：</strong>{{ selectedCompany.website }}</p>
                            <p><strong>公司简介：</strong>{{ selectedCompany.unitDescreation }}</p>
                            <p><strong>联系人：</strong>{{ selectedCompany.contacts }}</p>
                            <p><strong>联系方式：</strong>{{ selectedCompany.contactsPhone }}</p>
                        </div>
                        
                        <!-- 产品列表 -->
                        <div class="product-list">
                            <div v-for="product in productList" :key="product.id" class="product-item">
                                <div class="product-image">
                                    <img v-if="product.enclosure" :src="product.enclosure" :alt="product.productName">
                                    <img v-else src="../../../assets/image/default-product.png" :alt="product.productName">
                                </div>
                                <div class="product-details">
                                    <p><strong>产品名称：</strong>{{ product.productName }}</p>
                                    <p><strong>产品类别：</strong>{{ product.productType }}</p>
                                    <p><strong>产品分类：</strong>{{ product.categorize }}</p>
                                    <p><strong>规格：</strong>{{ product.size }}</p>
                                    <p><strong>主要有效成分：</strong>{{ product.factor }}</p>
                                    <p><strong>适用范围：</strong>{{ product.scope }}</p>
                                    <p><strong>产品型号：</strong>{{ product.product_sn }}</p>
                                </div>
                            </div>
                        </div>
                        
                        <div class="back-button">
                            <el-button @click="backToCompanyList">返回公司列表</el-button>
                        </div>
                    </div>
                    
                    <!-- 产品列表（待开发） -->
                    <div v-else-if="activeTab === 'product'">
                        <div class="product-list-all">
                            <p>产品列表功能待开发</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                activeTab: 'company', // company, product, productDetail
                companyList: [],
                companyTotal: 0,
                companyQueryParams: {
                    pageNum: 1,
                    pageSize: 15,
                },
                productList: [],
                selectedCompany: {},
            }
        },
        mounted() {
            this.getCompanyList();
        },
        methods: {
            // 获取公司列表
            getCompanyList() {
                this.$axios.get('/business/companyList', {
                    params: this.companyQueryParams
                }).then(res => {
                    this.companyList = res.data.rows;
                    this.companyTotal = res.data.total;
                }).catch(error => {
                    console.error('获取公司列表失败:', error);
                });
            },
            
            // 切换标签页
            switchTab(tab) {
                this.activeTab = tab;
                if (tab === 'company') {
                    this.getCompanyList();
                }
            },
            
            // 查看公司产品
            viewCompanyProducts(company) {
                this.selectedCompany = company;
                this.getProductListByCompany(company.unitName);
            },
            
            // 根据公司获取产品列表
            getProductListByCompany(companyName) {
                this.$axios.get('/business/productListByCompany', {
                    params: {
                        companyName: companyName
                    }
                }).then(res => {
                    this.productList = res.data.data;
                    this.activeTab = 'productDetail';
                }).catch(error => {
                    console.error('获取产品列表失败:', error);
                });
            },
            
            // 返回公司列表
            backToCompanyList() {
                this.activeTab = 'company';
            },
            
            // 分页相关方法
            handleCompanySizeChange(val) {
                this.companyQueryParams.pageSize = val;
                this.getCompanyList();
            },
            
            handleCompanyCurrentChange(val) {
                this.companyQueryParams.pageNum = val;
                this.getCompanyList();
            }
        }
    }
</script>

<style lang="scss" scoped>
    .product-service {
        margin: 20px 0;
        overflow: hidden;

        .row {
            width: 1000px;
            background-color: #FFF;
            margin: 0 auto;

            .w235 {
                width: 235px;
                left: -8px;

                .sideImg {
                    text-align: center;
                    padding: 20px 0;
                }
                
                .list {
                    ul {
                        li {
                            cursor: pointer;
                            
                            &.active {
                                background-color: #f0f9ff;
                                border-left: 3px solid #409eff;
                            }
                        }
                    }
                }
            }

            .w750 {
                width: 750px;
                position: relative;
                right: -7px;

                .pageBox2 {
                    min-height: 830px;
                    border: 1px #DDDDDD solid;
                    border-radius: 5px;
                    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12),
                        0 0 6px 0 rgba(0, 0, 0, 0.04);

                    .company-list,
                    .product-list-all {
                        padding: 45px 35px;
                        line-height: 20px;
                        text-align: justify;

                        ul {
                            li {
                                height: 41px;
                                line-height: 40px;
                                overflow: hidden;
                                position: relative;
                                background: url('../../../assets/image/line.gif') bottom repeat-x;

                                a {
                                    background: url('../../../assets/image/icons.gif') left center no-repeat;
                                    font-size: 14px;
                                    padding-left: 12px;
                                }

                                span {
                                    color: #999;
                                    position: absolute;
                                    top: 0px;
                                    right: 0px;
                                    white-space: nowrap;
                                }
                            }
                        }
                    }
                    
                    .company-info {
                        padding: 20px 35px;
                        border-bottom: 1px solid #eee;
                        
                        h3 {
                            color: #333;
                            margin-bottom: 15px;
                        }
                        
                        p {
                            margin: 8px 0;
                            line-height: 1.6;
                        }
                    }
                    
                    .product-list {
                        padding: 20px 35px;
                        
                        .product-item {
                            display: flex;
                            border: 1px solid #eee;
                            border-radius: 5px;
                            padding: 15px;
                            margin-bottom: 20px;
                            
                            .product-image {
                                width: 150px;
                                height: 150px;
                                margin-right: 20px;
                                
                                img {
                                    width: 100%;
                                    height: 100%;
                                    object-fit: cover;
                                }
                            }
                            
                            .product-details {
                                flex: 1;
                                
                                p {
                                    margin: 5px 0;
                                    line-height: 1.5;
                                }
                            }
                        }
                    }
                    
                    .back-button {
                        padding: 20px 35px;
                        text-align: center;
                    }

                    .pages {
                        padding: 20px 0;
                        display: flex;
                        justify-content: center;
                    }
                }
            }
        }
    }
</style>